import axios from 'axios';

export default class TelecomService {

    async callConference(shard, account, duration, type) {
        // console.log("xxx call conference", account)
        return axios.get("https://tapi.416inc.net/api/v1/conferenceMapper/call?shard="+shard+"&account="+account+"&duration="+duration+"&type="+type);
    }

    async callConferencePlaylist(shard, account, duration) {
        // console.log("xxx call conference playlist", account)
        return axios.get("https://tapi.416inc.net/api/v1/conferenceMapper/callPlaylist?shard="+shard+"&account="+account+"&duration="+duration);
    }
}

